import { call } from 'redux-saga/effects';
import { API_URL } from '../_config';
import { CallApi } from './api/callApi';
import { ActionExtended } from '../_common/interfaces/ActionExtended';

type SagaAction = ActionExtended & {
  callbackSuccess?: (data: unknown) => void;
  callbackError?: (data: unknown) => void;
};

type ApiResp = {
  status?: number;
  data?: { data?: unknown };
};

export function* getCmsContent(action: SagaAction): Generator {
    try {
        const data = action.payload;
        const resp = (yield call(CallApi.POST, API_URL.CMS.GET_CMS, data)) as ApiResp;
        if (resp.status && resp.status >= 200 && resp.status < 300 && resp.data && resp.data.data) {
            if (action?.callbackSuccess) {
              action.callbackSuccess(resp.data);
            }
        } else {
            if (action?.callbackError) {
              action.callbackError(resp.data);
            }
        }
    } catch (e) {
        if (action?.callbackError) {
          const err = e && typeof e === "object" && "data" in e ? (e as { data?: unknown }).data : e;
          action.callbackError(err);
        }
    }
}